import { ReceiptIcon, VerifiedStatusIcon } from '@bravemove/design-tokens/icons';
import { cn } from '../../utils/cn';

export interface CertBadgeProps {
  readonly name: string;
  readonly issuer: string;
  readonly expiry?: string;
  readonly verified?: boolean;
  readonly expiring?: boolean;
  readonly className?: string;
}

export function CertBadge({
  name,
  issuer,
  expiry,
  verified = false,
  expiring = false,
  className,
}: CertBadgeProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-xl bg-surface p-[11px_13px] border',
        verified ? 'border-success/35' : 'border-hairline-2',
        className,
      )}
    >
      <div
        className={cn(
          'flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[9px]',
          verified ? 'bg-success/10 text-ink' : 'bg-ink-3/10 text-ink',
        )}
      >
        <ReceiptIcon size={18} color="currentColor" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="text-[13px] font-bold text-ink truncate">{name}</span>
          {verified ? (
            // StatusIconProps accepts only `size`+`color` — wrap in a tinted span
            // so the glyph inherits `text-success` via currentColor.
            <span className="text-success inline-flex shrink-0">
              <VerifiedStatusIcon size={12} color="currentColor" />
            </span>
          ) : null}
        </div>
        <div className="mt-px text-[11px] font-medium text-ink-3 truncate">{issuer}</div>
      </div>
      <div className="shrink-0 text-end">
        {verified ? (
          <span
            className={cn(
              'font-mono text-[9.5px] font-bold',
              expiring ? 'text-ink bg-warning/15 rounded-sm px-1 py-0.5' : 'text-ink-2',
            )}
          >
            {expiry ? `EXP ${expiry}` : ''}
          </span>
        ) : (
          <span className="font-mono text-[9px] font-bold uppercase tracking-wider text-ink-3">
            UNVERIFIED
          </span>
        )}
      </div>
    </div>
  );
}
